import React from "react";

const fallbackComponent = () => {

  function handleReload() {
    window.location.reload();
  }

  return (
     <div className="h-[100vh] w-[100vw] flex justify-center items-center">
      <p>Failed to load. Please refresh.</p>
      <div
        className={`rista-sprite blue-refresh-copy rista-new-sprite cursor-pointer scale-125 ml-4`}
        onClick={() => handleReload()}
      ></div>
    </div>
  )
};

export function lazyWithHandler(factory: any, options = {fallback: fallbackComponent}) {
  const { fallback } = options;

  return React.lazy(() => {

    // Attempt dynamic import
    return factory()
      .then((module: any) => {
        console.log('[lazyWithHandler] Module loaded successfully.');
        return module;
      })
      .catch((error: any) => {
        console.error('[lazyWithHandler] Failed to load module:', error);
        // Return fallback module
        return {
          default: fallback
        };
      });
  });
}